import { render } from "./AddDelivery.vue?vue&type=template&id=138e507a&scoped=true"
import script from "./AddDelivery.vue?vue&type=script&lang=js"
export * from "./AddDelivery.vue?vue&type=script&lang=js"

import "./AddDelivery.vue?vue&type=style&index=0&id=138e507a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-138e507a"]])

export default __exports__